var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecorderTapeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 11C5.84315 11 4.5 12.3431 4.5 14C4.5 15.6569 5.84315 17 7.5 17C9.15685 17 10.5 15.6569 10.5 14C10.5 12.3431 9.15685 11 7.5 11ZM2.5 14C2.5 11.2386 4.73858 9 7.5 9C10.2614 9 12.5 11.2386 12.5 14C12.5 16.7614 10.2614 19 7.5 19C4.73858 19 2.5 16.7614 2.5 14Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 11C18.8431 11 17.5 12.3431 17.5 14C17.5 15.6569 18.8431 17 20.5 17C22.1569 17 23.5 15.6569 23.5 14C23.5 12.3431 22.1569 11 20.5 11ZM15.5 14C15.5 11.2386 17.7386 9 20.5 9C23.2614 9 25.5 11.2386 25.5 14C25.5 16.7614 23.2614 19 20.5 19C17.7386 19 15.5 16.7614 15.5 14Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 19H7.5V17H20.5V19Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorderTapeOutline);
export default __webpack_public_path__ + "static/media/recorder_tape_outline.a00affff2725f91979367a8e9f0cb898.svg";
export { ForwardRef as ReactComponent };